import React from "react"
export default function Tabs({tabs}) {
    const [activeTab, setActiveTab] = React.useState(0)
    return (
        <div className="flex flex-col w-full h-full">
            <div role="tablist" className="flex space-x-3 overflow-x-auto">
                {tabs.map((tab, tabIndex) => (
                    <button
                        key={tabIndex}
                        role="tab"
                        type="button"
                        aria-selected={activeTab === tabIndex}
                        aria-controls={`tabpanel-${tabIndex}`}
                        id={`tab-${tabIndex}`}
                        tabIndex={activeTab === tabIndex ? 0 : -1}
                        className={`w-full md:w-48 border-b-2 ${activeTab === tabIndex ? 'border-red-500' : ''} px-2 pt-1 pb-3 cursor-pointer w-32 bg-transparent focus:outline-none focus-visible:ring-inset focus-visible:ring-2 focus-visible:ring-red-500 transition-colors duration-200`}
                        onClick={() => setActiveTab(tabIndex)}
                        onKeyDown={(e) => {
                            if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
                                e.preventDefault();
                                const next = e.key === 'ArrowRight'
                                    ? (activeTab + 1) % tabs.length
                                    : (activeTab - 1 + tabs.length) % tabs.length;
                                setActiveTab(next);
                                e.currentTarget.parentElement.children[next].focus();
                            }
                        }}
                    >
                        <span className={`block text-center w-full rounded text-gray-800 px-2 py-1 ${activeTab === tabIndex ? 'font-bold' : 'hover:font-bold hover:bg-gray-100'}`}>
                            {tab.title}
                        </span>
                    </button>
                ))}
            </div>
            <div
                role="tabpanel"
                id={`tabpanel-${activeTab}`}
                aria-labelledby={`tab-${activeTab}`}
                className="flex py-3 w-full h-full overflow-y-auto outline-none"
            >
                {tabs[activeTab].content}
            </div>
        </div>
    )
}
